module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/sip.svg?828ef6d4";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/sip.svg
// module id = 1865
// module chunks = 0